/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Link,
  OutlinedInput,
  Paper,
  Slide,
  Typography,
  Select,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import * as PropTypes from "prop-types";
import { Field, Form, Formik } from "formik";
import AppButton from "./AppButton";
import {
  connectBank,
  getPockytBankFormData,
} from "../store/actions";
import { useDispatch, useSelector } from "react-redux";
import AppScreenLoader from "./AppScreenLoader";
import * as yup from "yup";
import { logEvent, setFiatBankDetails } from "../store/api";
import { SHOW_MESSAGE } from "../store/actions/actionTypes";
import { MESSAGE_BAR_TYPES, TRANSFER_MODE } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import { AppDatePicker } from "./AppDatePicker";
import moment from "moment";
import { EVENTS } from "../utils/events";
import { replaceLabels } from "../utils";

export default function PaymentForm({ active, setActive, currency, country, mode, setBank, setIsConflict, submitFlag = false }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isSmallMobile = useMediaQuery('(max-width:480px)');

  const bankForm = useSelector(({ transfer }) => transfer.pocFormAttribute);
  const bankToReplace = useSelector(({ transfer }) => transfer.bankToReplace);
  const [validation, setValidation] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const getValues = () => {
    let obj = {};
    const validations = {};
    Object.keys(bankForm || {}).forEach((key) => {
      const fields = bankForm[key];
      fields.forEach((field) => {
        if (field?.isEditable) {
          let schema = yup.string();
          if (field.minLength) {
            schema = schema.min(
              field.minLength,
              t("Min length is ") + field.minLength
            );
          }
          if (field.maxLength) {
            schema = schema.max(
              field.maxLength,
              t("Max length is ") + field.maxLength
            );
          }
          if (field.regex && typeof field.regex === "string") {
            schema = schema.matches(field.regex, "Invalid format.");
          }
          validations[field.name + key] = schema;
        }
        if (field.name === "country") {
          field.isEditable = false;
          field.value = country.iso2;
        }

        if (field.name === "bankCountry") {
          field.isEditable = false;
          field.value = country.iso2;
        }

        if (field.name === 'bankAccountPurpose' && !field.value) {
          field.value = field?.acceptedValues?.[0];
        }
        obj = { ...obj, [field.name + key]: field?.value };
      });
    });
    setValidation(validations);
    return obj;
  };
  const [initialValues, setInititalValues] = useState(() => getValues());
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);
  useEffect(() => {
    const values = getValues();
    setInititalValues(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankForm]);
  const handleFetchFormError = (err) => {
    if (err?.response?.data?.data) {
      // check if its a conflict
      if (err?.response?.data?.data?.isConflict) {
        setIsConflict(true)
        setLoading(false);
      }
    }
  }
  useEffect(() => {
    dispatch(getPockytBankFormData(currency.id, country.iso2, null, handleFetchFormError));
    logEvent({
      current: EVENTS.BANK_TRANSFER.BANK_FORM_LOADED,
      activity: EVENTS.BANK_TRANSFER.BANK_FORM_LOADED,
      meta: {
        country,
        currency,
        fiatService,
        mode
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleFormSubmit = async (data, { setErrors }) => {
    try {
      setLoading(true);
      if (isSubmitting) {
        return;
      }
      setIsSubmitting(true);
      const payload = {};
      Object.keys(bankForm || {}).forEach((key) => {
        const fields = bankForm[key];
        fields.forEach((field) => {
          if (data[field.name + key]) {
            if (field.name === 'dateOfBirth' && moment(data[field.name + key]).isValid()) {
              payload[key] = {
                ...payload[key],
                [field.name]: moment(data[field.name + key] || '').format('YYYY-MM-DD')
              }
            } else
              payload[key] = {
                ...payload[key],
                [field.name]: data[field.name + key],
              };
          }
        });
      });
      payload.currency = currency.id;
      payload.country = country.iso2;
      if (bankToReplace?.accountTag) {
        payload.bankToReplace = bankToReplace
      }
      const resp = await setFiatBankDetails(payload, payload.currency, payload.country);
      // dispatch(getPockytConnectedBanks());
      setIsComplete(true);
      setIsSubmitting(false);
      if (resp?.result?.account?.status === 1) {
        logEvent({
          current: EVENTS.BANK_TRANSFER.BANK_FORM_SAVED,
          activity: EVENTS.BANK_TRANSFER.BANK_FORM_SAVED,
          meta: {
            country,
            currency,
            fiatService,
            mode
          }
        });
        // it should be in order
        setBank(resp?.result?.account);
        setActive(4, 'summary');
        dispatch(connectBank(false));
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setIsSubmitting(false)
      setActive(3);
      dispatch({
        type: SHOW_MESSAGE,
        payload: {
          type: MESSAGE_BAR_TYPES.ERROR,
          message: err?.response?.data?.message || err.message,
        },
      });
      if (err?.response?.data?.data) {
        // check if its a conflict
        if (err?.response?.data?.data?.isConflict) {
          setIsConflict(true)
        } else setErrors(err?.response?.data?.data?.data);
      }
      logEvent({
        current: EVENTS.BANK_TRANSFER.BANK_FORM_ERROR,
        activity: EVENTS.BANK_TRANSFER.BANK_FORM_ERROR,
        meta: {
          error: err
        }
      });
    }
  };
  const handleBackToHome = () => {
    logEvent({
      current: EVENTS.BANK_TRANSFER.BANK_BACK_TO_HOME,
      activity: EVENTS.BANK_TRANSFER.BANK_BACK_TO_HOME,
      meta: {
        country,
        currency,
        fiatService,
        mode
      }
    });
    navigate('/home');
  }
  if (!bankForm || loading) {
    return <AppScreenLoader />;
  }
  if (isComplete) {
    return (
      <Box>
        <Typography variant="subtitle2" textAlign={"left"}
          marginBottom={2}
          fontWeight={700}
          sx={{ fontSize: "18px" }}>
          {t('pockyt.paymentMethodThanks')}
        </Typography>
        <Typography variant="subtitle2" textAlign={"left"} sx={{ fontSize: "12px" }}
          marginBottom={2}
        >
          {t('pockyt.paymentMethodThanksDesc')}
        </Typography>

        <Typography variant="subtitle2"
          data-i18n={`[html]pockyt.paymentMethodThanksSupport`}
          textAlign={"left"} sx={{ fontSize: "12px" }}>
          <Trans
            components={{
              a: (
                <Link
                  href="mailto:support@rocketfuel.inc"
                  target="_blank"
                  onClick={() => { }}
                />
              ),
            }}
          >
            {t('pockyt.paymentMethodThanksSupport')}

          </Trans>
        </Typography>
        <AppButton
          onClick={handleBackToHome}
          title={t("goHome")} />
      </Box>
    )
  }

  return (
    <Paper
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        maxHeight: mode === TRANSFER_MODE ? (isSmallMobile ? '57vh' : '65vh') : 'auto',
        overflowY: mode === TRANSFER_MODE ? "auto" : "none",
        paddingLeft: 1,
        paddingRight: 1,
        paddingBottom: mode === TRANSFER_MODE ? 0 : 5
      }}
    >
      {/* <Zoom in={true} style={{ transitionDelay: "50ms" }}> */}
      <Grid container marginTop={1} >
        <Grid item xs={12} sm={12}>
          <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Typography variant="subtitle2" textAlign={"left"}>
              {!submitFlag ? t("addbank.subtitle1") : t("bank.verification1")}
            </Typography>
          </Slide>
          <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Typography variant="subtitle2" textAlign={"left"} marginTop={1}
              data-i18n={`[html]addbank.subtitle2`}>
              <Trans
                components={{
                  a: (
                    <Link
                      href="mailto:support@rocketfuel.inc"
                      target="_blank"
                      onClick={() => { }}
                    />
                  ),
                }}
              >
                {!submitFlag ? t("addbank.subtitle3") : `${t("bank.verification2")}`}
              </Trans>
            </Typography>
          </Slide>

          {!submitFlag && <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Typography
              variant="subtitle2"
              textAlign={"left"}
              data-i18n={`[html]addbank.subtitle2`}
              marginTop={1}
            >
              <Trans
                components={{
                  a: (
                    <Link
                      href="mailto:support@rocketfuel.inc"
                      target="_blank"
                      onClick={() => { }}
                    />
                  ),
                }}
              >
                {t(`addbank.subtitle2`)}.
              </Trans>
            </Typography>
          </Slide>}
          <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Box marginTop={2}>
              <Formik
                initialValues={initialValues}
                onSubmit={handleFormSubmit}
                enableReinitialize={true}
                validate={async (values) => {
                  const errors = {};
                  for (const key in values) {
                    if (values[key] !== "" && validation[key]) {
                      try {
                        validation[key].validateSync(values[key], {
                          abortEarly: false,
                        });
                      } catch (err) {
                        err.inner.forEach((error) => {
                          errors[key] = t(error.message);
                        });
                      }
                    }
                  }
                  return errors;
                }}
              >
                {({ handleSubmit, isSubmitting, isValid, errors }) => (
                  <Form onSubmit={handleSubmit} autoComplete="off" style={{ marginBottom: 20 }}>
                    {Object.keys(bankForm).map((key) => (
                      <Box key={key}>
                        {bankForm[key].map((data) => (
                          <Field key={data.name + key} name={data.name + key}>
                            {({ field }) => (
                              <Box key={data.name + key}>
                                <InputLabel htmlFor={data.name + key}>
                                  {t(`${replaceLabels(data.label)}`)}
                                  {data.isRequired && (
                                    <sup style={{ color: "#FF9494" }}>*</sup>
                                  )}
                                </InputLabel>
                                <FormControl
                                  fullWidth
                                  variant="outlined"
                                  required={data.isRequired}
                                  disabled={!data.isEditable}
                                >
                                  {(data.type !== 'select' && data.name !== 'dateOfBirth') &&
                                    <OutlinedInput
                                      {...field}
                                      id={data.name + key}
                                      label={t(`${data.label}`)}
                                      placeholder={`${(data.placeholder || '')}`}
                                      autoComplete="off"
                                    />
                                  }
                                  {
                                    (data.name === 'dateOfBirth') &&
                                    <AppDatePicker
                                      {...field}
                                      name={data.name + key}
                                      id={data.name + key}
                                      format={'YYYY-MM-DD'}
                                      required={data.isRequired}
                                      inputProps={{
                                        max: new Date().toISOString().split('T')[0], // Format as YYYY-MM-DD
                                      }}
                                    />
                                  }
                                  {(data.type === 'select') &&
                                    <Select
                                      {...field}
                                      id={data.name + key}
                                      label={t(`${data.label}`)}
                                      autoComplete="off"
                                      value={field.value || data.acceptedValues[0]}
                                      SelectDisplayProps={{
                                        style: {
                                          fontSize: 14,
                                          fontWeight: 500,
                                        }
                                      }}
                                    >
                                      {
                                        data.acceptedValues.map((value) => (
                                          <MenuItem key={value} value={value} style={{ color: '#333' }}>
                                            {value}
                                          </MenuItem>
                                        ))
                                      }
                                    </Select>
                                  }
                                </FormControl>
                                <FormHelperText
                                  sx={{ color: "#FF9494", fontSize: 12 }}
                                >
                                  {errors?.[data.name + key]}
                                </FormHelperText>
                              </Box>
                            )}
                          </Field>
                        ))}
                      </Box>
                    ))}
                    <Box sx={{ marginTop: 2 }}>
                      <Typography
                        fontSize={12}
                        fontFamily={"Manrope"}
                        color={"#FF9494"}
                        textAlign={"right"}
                      >
                        * {t("requiredField")}
                      </Typography>
                    </Box>
                    <AppButton
                      type="submit"
                      disabled={!isValid || isSubmitting}
                      loading={isSubmitting}
                      title={submitFlag ? t("Submit") : t("loginPage.continue")}
                      sx={{ marginTop: 2 }}
                    />

                  </Form>
                )}
              </Formik>
            </Box>
          </Slide>
        </Grid>
      </Grid>
      <Typography>
        {t('bankDesclaimer')}
      </Typography>
      {/* </Zoom> */}
    </Paper>
  );
}

PaymentForm.propTypes = {
  paymentMethod: PropTypes.object,
  paymentCurrency: PropTypes.string,
  editValue: PropTypes.object,
  setActive: PropTypes.func,
  active: PropTypes.number,
  newMode: PropTypes.bool,
  disableNewMode: PropTypes.func,
};
